import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions'
import StoneTable, { formatStatus } from './stone_table';
import ConfirmStonesModal from './confirm_stones_modal'
import {OptionsFilter, filterOptions, NumberFilter, filterNumber} from '../common/filters';
import { error } from '../common/toast';

class MyMelee extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStones: {},
            returnRemarks: null,
            saleRemarks: null,
            returnAmounts: {},
            saleAmounts: {}
        };
    }

    componentDidMount() {
        this.refresh();
    }

    refresh = () => {
        this.props.getCurrentMelee()
    }

    handleRowSelect = (selected) => {
        this.setState({selectedStones: selected});
    }

    getSelectedStones = () => {
        if (!this.state.selectedStones) return [];
        return Object.keys(this.state.selectedStones).filter(parcelName => this.state.selectedStones[parcelName]);
    }

    removeSelectedStone = parcelName => {
        this.setState({selectedStones: {...this.state.selectedStones, [parcelName]: false}})
    }

    returnStones = () => {
        const selected = this.getSelectedStones();
        if (!selected.length) return;
        const stones = selected.map(parcelName => ({parcelName, ...this.state.returnAmounts[parcelName]}))
        const errors = this.checkAmounts(stones)
        if (errors.length) {
            errors.forEach(e => error(e));
            return Promise.reject();
        }
        return this.props.returnMelee(stones, this.state.returnRemarks)
        .then(() => this.setState({returnRemarks: null, selectedStones: {}}))
        .then(this.refresh)
    }

    sellStones = () => {
        const selected = this.getSelectedStones();
        if (!selected.length) return;
        const stones = selected.map(parcelName => ({parcelName, ...this.state.saleAmounts[parcelName]}))
        const errors = this.checkAmounts(stones)
        if (errors.length) {
            errors.forEach(e => error(e));
            return Promise.reject();
        }
        return this.props.sellMelee(stones, this.state.saleRemarks)
        .then(() => this.setState({saleRemarks: null, selectedStones: {}}))
        .then(this.refresh)
    }

    checkAmounts = stones => {
        const errors = []
        for (const amount of stones) {
            if (!amount.weight || !amount.quantity) {
                errors.push(`Please enter weight and quantity for stone ${amount.parcelName}`)
            } else {
                const inventoryStone = (this.props.inventory || []).find(s => s.parcelName === amount.parcelName)
                if (inventoryStone &&  amount.weight > inventoryStone.deployedWeight) {
                    errors.push(`Weight exceeds deployed weight (${inventoryStone.deployedWeight}) for stone ${amount.parcelName}`)
                }
                if (inventoryStone && amount.quantity > inventoryStone.deployedQuantity) {
                    errors.push(`Quantity exceeds deployed quantity (${inventoryStone.deployedQuantity}) for stone ${amount.parcelName}`)
                }
            }
        }
        return errors;
    }

    StatusFilter = props => <OptionsFilter data={this.props.inventory || []} {...props} />

    renderInventory = () => {
        const selectedStones = this.getSelectedStones();
        const inventory = this.props.inventory || [];
        return (
            <div>
                <div className='row spaced'>
                    <ConfirmStonesModal
                        confirm={this.returnStones} 
                        title='Confirm Return'
                        message={`Review ${selectedStones.length} stones and click "Return Stones" to confirm.`} 
                        confirmCaption='Return Stones'
                        deleteStone={this.removeSelectedStone}
                        trigger={onClick => <button className='btn tabletop-btn' onClick={onClick} disabled={selectedStones.length==0}>Return</button>}
                        stones={
                            inventory.filter(stone => selectedStones.includes(stone.parcelName))
                        }
                        comment={this.state.returnRemarks}
                        updateComment={(e) => this.setState({returnRemarks: e.target.value})}
                        amounts={this.state.returnAmounts}
                        updateAmounts={({parcelName, ...amount}) => this.setState({returnAmounts: {...this.state.returnAmounts, [parcelName]: amount}})}
                    />
                    &nbsp;
                    <ConfirmStonesModal
                        confirm={this.sellStones} 
                        title='Confirm Sale'
                        message={`Review ${selectedStones.length} stones and click "Sell Stones" to confirm.`} 
                        confirmCaption='Sell Stones'
                        deleteStone={this.removeSelectedStone}
                        trigger={onClick => <button className='btn tabletop-btn' onClick={onClick} disabled={selectedStones.length==0 || selectedStones.some(p => p.startsWith('desire-'))}>Sold</button>}
                        stones={inventory.filter(stone => selectedStones.includes(stone.parcelName))}
                        comment={this.state.saleRemarks}
                        updateComment={(e) => this.setState({saleRemarks: e.target.value})}
                        amounts={this.state.saleAmounts}
                        updateAmounts={({parcelName, ...amount}) => this.setState({saleAmounts: {...this.state.saleAmounts, [parcelName]: amount}})}
                    />
                </div>
                <StoneTable 
                    labGrown={true}
                    data={inventory} 
                    extraColumns={[
                        {
                            Header: 'Status', 
                            id: 'status', 
                            accessor: formatStatus,
                            minWidth: 80,
                            Filter: this.StatusFilter, 
                            filterMethod: filterOptions,
                        },
                        /*{
                            Header: 'Days On Hand',
                            accessor: 'daysOnHand',
                            minWidth: 80,
                            Filter: NumberFilter,
                            filterMethod: filterNumber,
                            includeExcel: true
                        }*/
                    ]}
                    selectedRows={this.state.selectedStones}
                    onSelectRows={this.handleRowSelect}
                    hideTier={false}
                    showOrigin={true}
                    exporter={this.props.excelMeleeExport}
                    tableId='currentMelee'
                />
            </div>
        )
    }

    render() {
        return (
            <div style={{width: '100%'}}>
                {this.renderInventory()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        inventory: state.melee.my
    }
}

export default connect(mapStateToProps, actions)(MyMelee)